export interface ISiteState {
  selectedSite: string | null;
  selectedStudy: string | null;
  selectedCountry: string | null;
  selectedSiteRole: string | null;
  siteClicksData: any;
  sitePermissionData: any;
  currentHierarchyLevel: string | null;
  isHierarchyLevelClosed: boolean;
  userAccessData: any;
  siteInfo: any;
}

export const SITE_HIERARCHY_VALUE = 'site';
export const COUNTRY_HIERARCHY_VALUE = 'country';
export const STUDY_HIERARCHY_VALUE = 'study';
